import { useEffect, useState } from "react";

const getScrollState = () => {
  const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;

  const scrollHeight =
    document.documentElement.scrollHeight - window.innerHeight;

  const progress =
    scrollHeight > 0 ? Math.min(100, Math.max(0, (scrollTop / scrollHeight) * 100)) : 0;

  return {
    scrollTop,
    progress,
    visible: scrollTop > 280,
  };
};

export default function useScrollProgress() {
  const [state, setState] = useState({
    scrollTop: 0,
    progress: 0,
    visible: false,
  });

  useEffect(() => {
    let ticking = false;

    const update = () => {
      setState(getScrollState());
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };

    update();

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  return state;
}